"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _tokenPanelPro = _interopRequireDefault(require("./token-panel-pro"));
var _ComponentDemoPro = _interopRequireDefault(require("./token-panel-pro/ComponentDemoPro"));
var _makeStyle = _interopRequireDefault(require("./utils/makeStyle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyle = (0, _makeStyle.default)('GlobalTokenEditor', function (token) {
  return (0, _defineProperty2.default)({}, token.componentCls, (0, _defineProperty2.default)({
    display: 'flex',
    height: '100%'
  }, "".concat(token.componentCls, "-token-panel-wrapper"), {
    backgroundColor: token.colorBgContainer,
    height: '100%',
    backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0, 0, 0, 0.02) 100%)',
    display: 'flex',
    transition: 'all 0.3s'
  }));
});
var GlobalTokenEditor = function GlobalTokenEditor(props) {
  var theme = props.theme,
    infoFollowPrimary = props.infoFollowPrimary,
    onInfoFollowPrimaryChange = props.onInfoFollowPrimaryChange,
    children = props.children;
  var prefixCls = 'antd-global-token-editor';
  var _useStyle = useStyle(prefixCls),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  var _useState = (0, _react.useState)({
      seed: ['colorPrimary']
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedTokens = _useState2[0],
    setSelectedTokens = _useState2[1];
  var handleTokenSelect = function handleTokenSelect(token, type) {
    setSelectedTokens(function (prev) {
      var tokens = typeof token === 'string' ? token ? [token] : [] : token;
      if (type === 'seed') {
        return {
          seed: tokens
        };
      }
      var newSelectedTokens = _objectSpread({}, prev);
      tokens.forEach(function (newToken) {
        var _prev$type, _prev$type2, _prev$type3;
        newSelectedTokens = _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, type, (_prev$type = prev[type]) !== null && _prev$type !== void 0 && _prev$type.includes(newToken) ? (_prev$type2 = prev[type]) === null || _prev$type2 === void 0 ? void 0 : _prev$type2.filter(function (t) {
          return t !== newToken;
        }) : [].concat((0, _toConsumableArray2.default)((_prev$type3 = prev[type]) !== null && _prev$type3 !== void 0 ? _prev$type3 : []), [newToken])));
      });
      if (type === 'map') {
        delete newSelectedTokens.alias;
      }
      return newSelectedTokens;
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(hashId, prefixCls)
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: "0 0 480px"
    },
    className: "".concat(prefixCls, "-token-panel-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_tokenPanelPro.default, {
    theme: theme,
    style: {
      flex: 1
    },
    selectedTokens: selectedTokens,
    onTokenSelect: handleTokenSelect,
    infoFollowPrimary: infoFollowPrimary,
    onInfoFollowPrimaryChange: onInfoFollowPrimaryChange
  })), children || /*#__PURE__*/_react.default.createElement(_ComponentDemoPro.default, {
    theme: theme,
    style: {
      flex: 1,
      overflow: 'auto',
      height: '100%'
    }
  }));
};
var _default = exports.default = GlobalTokenEditor;